import { rpcClient } from "@/api/WebsocketClient"
import SWR, { Call } from "@/api/SWR"
import { reactive } from "@vue/reactivity"
import SortAndFilterUtil from "@/util/SortAndFilterUtil"
import FromAddress from '@/model/settings/FromAddress';
import Page from '@/model/Page';
import { fromAddressStore } from '@/store/FromAddressStore';

export default class GeneratedFromAddressesApi {

    cache: Map<string, Call<any>> = new Map<string, Call<any>>()

    constructor() {
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.apis.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    clearState() {
        this.cache = new Map<string, Call<any>>()
    }

    get connected(): boolean {
        return rpcClient.state.connected
    }

    _getAllowedFromAddresses(): Promise<FromAddress[]> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('getAllowedFromAddresses', rpcParams, true).then((data: any) => {
            if (data && Array.isArray(data)) {
                const fromAddresss: FromAddress[] = data.map(fromAddress => Object.assign(new FromAddress(), fromAddress))
                fromAddressStore.replaceFromAddresss(fromAddresss)
                return fromAddresss
            } else return Promise.reject()
        })
    }


    getAllowedFromAddresses(refresh?: boolean | number): SWR<FromAddress[], string[]> {
        //@ts-ignore
        const result: SWR<FromAddress[], string[]> = reactive(new SWR<FromAddress[], string[]>())
        const args: any[] = Array.prototype.slice.call(arguments, 0, 0).filter(arg => arg !== undefined)
        const callId: string = '_getAllowedFromAddresses' + JSON.stringify(args)
        const cached: Call<string[]> | undefined = this.cache.get(callId)
        if (refresh === undefined && cached && cached.ended) {
            for (const [ id, call ] of this.cache) {
                if (id.startsWith('_getAllowedFromAddresses[') && id !== callId && (!call.ended || call.ended > cached.ended)) {
                    refresh = 3000
                    break
                }
            }
        }
        if (cached && !cached.ended) {
            result.call = cached
            cached.promise?.then((data: string[]) => {
                const fromAddresss: FromAddress[] = []
                for (const id of data) {
                    const fromAddress: FromAddress | undefined = fromAddressStore.state.fromAddresss.get(id)
                    if (fromAddress) {
                        fromAddresss.push(fromAddress)
                    }
                }
                result.data = fromAddresss
            })
        } else if (refresh !== -1 && (!cached || refresh === true || (typeof refresh === 'number' && (cached.ended || 0) < (Date.now() - refresh)))) {
            const call = reactive(new Call<string[]>()) as Call<string[]>
            this.cache.set(callId, call)
            call.loading = !cached
            call.refreshing = !!cached
            //@ts-ignore since Array.filter does not provide nullsafe guard
            call.promise = this._getAllowedFromAddresses().then((data: FromAddress[]) => {
                //@ts-ignore since Array.filter does not provide nullsafe guard
                result.data = data
                //@ts-ignore since Array.filter does not provide nullsafe guard
                call.data = data.map(fromAddress => fromAddress.name || '')
                return call.data
            }).catch(e => {
                setTimeout(() => {
                  this.cache.delete(callId)
                }, 1000)
                return Promise.reject(e)
            }).finally(() => {
                call.ended = Date.now()
                call.loading = false
                call.refreshing = false
            })
            result.call = call
        }
        let fromAddresss: FromAddress[] = [...fromAddressStore.state.fromAddresss.values()]
        
        
        
        result.data = fromAddresss
        return result
    }

    getFromAddress(name: string): FromAddress | undefined {
        return fromAddressStore.state.fromAddresss.get(name)
    }
}
